import React from "react";
import './PricingDashboardTableRow.css';
import Tooltip from "@material-ui/core/Tooltip";
import {APPLY_EDIT_ENTRY, CANCEL_EDIT_ENTRY, DETAIL, EDIT_ENTRY, PRICING_DASHBOARD_PAGES} from "../constants";
import EditIcon from "@material-ui/icons/Edit";
import { IconButton, Popover, TableCell, TextField, Switch, Button } from '@material-ui/core';
import ClearIcon from '@mui/icons-material/Clear';
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import withShipment from "../../../withShipment";
import {  updatePricingListing, updateRepricing } from '../../../redux/actions/settings';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import StyledBadge from "@material-ui/core/Badge";
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import StickyNote2OutlinedIcon from '@mui/icons-material/StickyNote2Outlined';
import Top3BuyBoxOffer from "./Top3BuyBoxOffer";
import { Autocomplete, Dialog, DialogActions, DialogContent, DialogTitle, Rating } from '@mui/material';
import Grid from '@material-ui/core/Grid';
import InsightsIcon from '@mui/icons-material/Insights';
import InputAdornment from '@material-ui/core/InputAdornment';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import RefreshIcon from '@material-ui/icons/Refresh';

class PricingDashboardTableRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            buyBoxAnchorEl: null,
            dialogOpen: false,
            allBoxes: this.props.packages || [],
            productForm: {
                repricing: false,
                webstoreProductId: null,
                shortcode: '',
                price: '',
                min: '',
                max: '',
                currency: '',
                packOf: '',
                referralFee: this.props.automationSettings?.referralFee || 0,
                packagingCost: '',
                avgShippingCost: '',
                ftlCost: '',
                packaging: '',
                productCost: '',
                profit: '',
                profitPerUnit: ''
            }
        };
    }

    componentDidMount() {

       let allBoxCodes = this.props.packages.map(item =>item.shortcode + " " + "(" + item.nominalSize + ")");
       this.setState({
          allBoxes: [
            ...(allBoxCodes?.sort((a, b) => a?.toLowerCase().localeCompare(b?.toLowerCase())) || []),
            'Other'
          ]
        })

        let newState = {
            deleteListing: false,
            shortcode: this.props.row.shortcode,
            newPrice: 0,
            newMinimum: 0,
            newMaximum: 0,
            newRepricing: false,
            newQuantity: 0

        }
        this.props.setRowState(newState)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.listingIdBeingEdited !== this.props.listingIdBeingEdited) {
            if (this.props.listingIdBeingEdited === this.props.row.webstoreProductId) {
                this.props.setRowState({
                    shortcode: this.props.row.shortcode,
                    newPrice: this.props.row.price,
                    newMinimum: this.props.row.minimumPrice,
                    newMaximum: this.props.row.maximumPrice,
                    newRepricing: this.props.row.repricing,
                })
            }
        }
    }

    handleLaunchClick = (row) => {
      const referralFee = Number(this.props.automationSettings?.referralFee || 0);
      const reference3 = `(${row.shortcode})-${row.quantity}`;
      const shipAddressId = row?.shipAddressId;
      const currency = Array.isArray(row.marketplaces) && row.marketplaces.includes("Amazon.com") ? 'USD' : 'CAD';

      const productForm = {
        webstoreProductId: row.webstoreProductId,
        repricing: row.repricing,
        shortcode: row.shortcode,
        price: row.price || 0,
        min: row.minimumPrice || '',
        max: row.maximumPrice || '',
        currency,
        shipAddressId,
        packOf: row.quantity,
        referralFee,
        packagingCost: 0,
        avgShippingCost: 0,
        ftlCost: 0,
        packaging: '',
        productCost: 0,
        profit: 0,
        profitPerUnit: 0,
        margin: 0,
        totalCost: 0,
      };

      this.props.fetchPackageDetailsWithCosts({ reference3, shipAddressId ,currency}, (data) => {
        const updatedForm = {
          ...productForm,
          packaging: data.packaging,
          packagingCost: Number(data.boxCost || 0),
          avgShippingCost: Number(data.shippingCost || 0),
          ftlCost: Number(data.ftlCost || 0),
          productCost: Number(data.productCost || 0),
          price: Number(row.price)
        };

        const pricing = this.calculatePricing(updatedForm);

        this.setState({
          productForm: { ...updatedForm, ...pricing },
          dialogOpen: true
        });
      });
    };

    handleDialogClose = () => {
        this.setState({ dialogOpen: false },()=>{
            this.props.setListingIdBeingEdited("")
        })
    }

    handleFormChange = (field) => (event, value) => {
    const newValue = event?.target ? event.target.value : value;

    this.setState(prevState => {
      const updatedForm = { ...prevState.productForm, [field]: newValue };
      const pricing = this.calculatePricing(updatedForm);

      return {
        productForm: { ...updatedForm, ...pricing }
      };
    });
  };


    handleApply = () => {

        let state = this.state.productForm

        if (!state.price) {
            return
        }

       this.props.setListingIdBeingEdited("")
        const request = {
            id: state.webstoreProductId,
            price: state.price,
            minimumPrice: state.min === "0.00" ? "" : state.min,
            maximumPrice: state.max === "0.00" ? "" : state.max,
            repricing: state.repricing,
        };

        this.props.updatePricingListing(request);

        this.handleDialogClose();
    }


    handleBuyBoxOpen  = (event) => {
        this.setState({ buyBoxAnchorEl: event.currentTarget });
    };

    handleBuyBoxPopoverClose = () => {
        this.setState({ buyBoxAnchorEl: null });
    };


    isBuyBoxPopoverOpen = () => {
        return Boolean(this.state.buyBoxAnchorEl);
    };

    handleCancel = (row) => {
        this.props.setListingIdBeingEdited("")
        this.props.setRowState({
            newPrice: 0,
            newMinimum: 0,
            newMaximum: 0,
            newRepricing: false,
        })
    }

    handleConfirm = (row) => {
        let state = this.props.getRowState()
        if (!state.newPrice) {
            return
        }

        this.props.setListingIdBeingEdited("")
        const request = {
            id: row.webstoreProductId,
            price: state.newPrice,
            minimumPrice: state.newMinimum,
            maximumPrice: state.newMaximum,
            repricing: state.newRepricing,
        };
        this.props.setRowState({
            newPrice: 0,
            newMinimum: 0,
            newMaximum: 0,
            newRepricing: false,
        })
        this.props.updatePricingListing(request);
    }

    getEditingCancelConfirm = (row) => {
        return <>
            <div>
                <Tooltip title={CANCEL_EDIT_ENTRY}>
                    <IconButton onClick={() => this.handleCancel(row)}>
                        <ClearIcon
                            fontSize='small'
                            color='error'
                        />
                    </IconButton>
                </Tooltip>
            </div>
        </>
    }

    displayPriceEditingTextField = () => {
        let state = this.props.getRowState()
        return <TextField
            variant="outlined"
            name="price"
            label="Price"
            value={state.newPrice}
             inputProps={{ style: { textAlign: "right" } }}
            InputProps={{ startAdornment: <InputAdornment position="start">{"$"}</InputAdornment>, readOnly: false }}

            onChange={(e) => this.props.setRowState({ newPrice: e.target.value })}
            error={state.newPrice === '' || state.newPrice === null || state.newPrice === undefined}
        />
    }

    displayMinimumPriceEditingTextField = () => {
        let state = this.props.getRowState()
        return <TextField
            variant="outlined"
            name="minimumPrice"
             inputProps={{ style: { textAlign: "right" } }}
             InputProps={{ startAdornment: <InputAdornment position="start">{"$"}</InputAdornment>, readOnly: false }}
            label="Minimum"
            value={state.newMinimum}
            onChange={(e) => this.props.setRowState({ newMinimum: e.target.value })}
        />
    }
    displayMaximumPriceEditingTextField = () => {
        let state = this.props.getRowState()
        return <TextField
            variant="outlined"
            name="maximumPrice"
             inputProps={{ style: { textAlign: "right" } }}
             InputProps={{ startAdornment: <InputAdornment position="start">{"$"}</InputAdornment>, readOnly: false }}
            label="Maximum"
            value={state.newMaximum}
            onChange={(e) => this.props.setRowState({ newMaximum: e.target.value })}
        />
    }

    displayRepircingField = (row) => {
        return <Switch
            color='primary'
            checked={row.repricing}
            disabled={this.disableRepricing(row.minimumPrice, row.maximumPrice)}
            onChange={(event) => this.handleRepricingChange(event, row)}
        />
    }

    handleRepricingChange = (event, row) => {
        this.props.setRowState({
            newRepricing: event.target.checked
        });
        let state = this.props.getRowState()
        const request = {
            id: row.webstoreProductId,
            repricing: state.newRepricing,
        };
        this.props.updateRepricing(request);
    };

    disableRepricing= (min, max) => {
        return min == null || min === undefined || min === "" || max == null || max === undefined || max === "";

    }

    displayNotesIcon = (row) => {
        let hasNotes = row.notes && row.notes.length > 0;
        return (
            <>
                <StickyNote2OutlinedIcon style={{ visibility: hasNotes ? 'visible' : 'hidden' }} />
            </>
        );
    }

    buyBoxInformation = (row) => {
        return <React.Fragment>
            <Top3BuyBoxOffer
                row={row}
            />
        </React.Fragment>
    }

    userHasMarginPricingAnalysisPermission = () => {
       const userRoutes = this.props.user?.routes || []
       return userRoutes.includes('view-profit-margin')
    }

    userHasProductCostAnalysisPermission = () => {
       const userRoutes = this.props.user?.routes || []
       return userRoutes.includes('view-product-cost')
    }

    userHasShippingCostAnalysisPermission = () => {
       const userRoutes = this.props.user?.routes || []
       return userRoutes.includes('view-shipping-cost')
    }

    userHasFTLCostAnalysisPermission = () => {
       const userRoutes = this.props.user?.routes || []
       return userRoutes.includes('view-ftl-cost')
    }

    userHasPackagingCostAnalysisPermission = () => {
       const userRoutes = this.props.user?.routes || []
       return userRoutes.includes('view-packaging-cost')
    }

    userHasProfitAnalysisPermission = () => {
       const userRoutes = this.props.user?.routes || []
       return userRoutes.includes('view-profit')
    }

    displayEditingRow = (row) => {
        const { anchorEl } = this.state;

        return (
          <React.Fragment>
            <TableCell style={{ width: '76px' }}>
              {this.getEditingCancelConfirm(row)}
            </TableCell>
            <TableCell
              style={{ minWidth: '100px', width: '10%', paddingLeft: '3px' }}
            >
              {row.shortcode}
            </TableCell>
            <TableCell
              style={{ minWidth: '100px', width: '16%', paddingLeft: '3px' }}
            >
              <br></br>
              {row.sku}
              <br></br>
              {row.shipAddressId && (
                <div>({this.props.matchLocations(row.shipAddressId)})</div>
              )}
            </TableCell>
            <TableCell
              style={{ minWidth: '50px', width: '6%', paddingLeft: '7px' }}
            >
              {row.quantity}
            </TableCell>
            <TableCell
              style={{ minWidth: '100px', width: '10%', paddingLeft: '3px' }}
            >
              <a
                href={`https://www.${row.marketplaces[0]}/dp/${row.asin}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'black' }}
              >
                {row.asin}
              </a>
            </TableCell>
            <TableCell
              style={{ minWidth: '80px', width: '9%', paddingLeft: '3px' }}
            >
              {row.marketplaces[0]}
            </TableCell>
            <TableCell
              style={{ minWidth: '80px', width: '8%', paddingLeft: '3px' }}
            >
              {this.displayPriceEditingTextField()}
            </TableCell>
            <TableCell
              style={{ minWidth: '80px', width: '8%', paddingLeft: '3px' }}
            >
              {this.displayMinimumPriceEditingTextField()}
            </TableCell>
            <TableCell
              style={{ minWidth: '80px', width: '8%', paddingLeft: '3px' }}
            >
              {this.displayMaximumPriceEditingTextField()}
            </TableCell>
            <TableCell
              style={{ minWidth: '80px', width: '7%', paddingLeft: '3px' }}
            >
              <Tooltip title={APPLY_EDIT_ENTRY}>
                <IconButton onClick={() => this.handleConfirm(row)}>
                  <CheckCircleIcon fontSize="small" color="secondary" />
                </IconButton>
              </Tooltip>
            </TableCell>
            <TableCell style={{ minWidth: '80px', width: '13%' }}>
              {this.displayNotesIcon(row)}
              <IconButton onClick={this.handleBuyBoxOpen}>
                {row.isBuyBoxWinner && row.has2BuyBoxWinners ? (
                  <ThumbUpAltIcon style={{ color: 'gray' }} />
                ) : row.isBuyBoxWinner && !row.has2BuyBoxWinners ? (
                  <ThumbUpAltIcon style={{ color: 'black' }} />
                ) : (
                  <ThumbUpOffAltIcon />
                )}
              </IconButton>
              <Popover
                open={this.isBuyBoxPopoverOpen()}
                anchorEl={this.state.buyBoxAnchorEl}
                onClose={this.handleBuyBoxPopoverClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
              >
                {this.buyBoxInformation(row)}
              </Popover>
              <StyledBadge
                badgeContent={row.relatedProducts?.length}
                color="secondary"
                style={{ marginLeft: '13px', marginRight: '6px' }}
              ></StyledBadge>
              <Tooltip title={DETAIL}>
                <IconButton
                  onClick={() => {
                    this.props.setCurrentPage(
                      PRICING_DASHBOARD_PAGES.DETAIL,
                      row.webstoreProductId
                    );
                  }}
                >
                  <KeyboardDoubleArrowRightIcon disable={true} />
                </IconButton>
              </Tooltip>
            </TableCell>
          </React.Fragment>
        );
    }

    displayNonEditingRow = (row) => {
        const { anchorEl } = this.state;
        const salesDetail = this.props.salesData?.[row.sku];
        const ratingNumber = salesDetail?.rating === "" || salesDetail?.rating == null ? 0 : Number(salesDetail.rating);

        return (
          <React.Fragment>
            <TableCell style={{ width: '76px' }}>
              <Tooltip title={EDIT_ENTRY}>
                <IconButton
                  onClick={() =>
                    this.props.setListingIdBeingEdited(row.webstoreProductId)
                  }
                >
                  <EditIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </TableCell>
            <TableCell
              style={{ minWidth: '100px', width: '10%', paddingLeft: '3px' }}
            >
              {row.shortcode}
            </TableCell>
            <TableCell
              style={{ minWidth: '100px', width: '16%', paddingLeft: '3px' }}
            >
              <br></br>
              {row.sku}
              <br></br>
              {row.shipAddressId && (
                <div>({this.props.matchLocations(row.shipAddressId)})</div>
              )}
              <br></br>
              {this.props.expandedRows && (
                <div style={{ marginTop: 5, marginBottom: 0 }}>
                  <span style={{ fontWeight: 700 }}>Units Sold:</span>{' '}
                  {salesDetail?.sku ?? ''}
                </div>
              )}
            </TableCell>
            <TableCell
              style={{ minWidth: '50px', width: '6%', paddingLeft: '7px' }}
            >
              {row.quantity}
            </TableCell>
            <TableCell
              style={{ minWidth: '100px', width: '10%', paddingLeft: '3px' }}
            >
              <a
                href={`https://www.${row.marketplaces[0]}/dp/${row.asin}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'black' }}
              >
                {row.asin}
              </a>
              <br></br>
              {this.props.expandedRows && (
                <div>
                  <div style={{ marginTop: 5, marginBottom: 0 }}>
                    <span style={{ fontWeight: 700 }}>Units Sold:</span>{' '}
                    {salesDetail?.asin ?? ''}
                  </div>

                  <div style={{ marginTop: 5, marginBottom: 0 }}>
                    <span style={{ fontWeight: 700 }}>Monthly Sold:</span>{' '}
                    {salesDetail?.monthlySold ?? ''}
                  </div>

                  <div
                    style={{
                      marginTop: 5,
                      marginBottom: 0,
                      display: 'flex',
                      alignItems: 'center',
                      columnGap: 6,
                    }}
                  >
                    <span style={{ fontWeight: 700 }}>Rating:</span>
                    <Rating
                      name="half-rating-read"
                      value={ratingNumber ? ratingNumber : 0}
                      precision={0.1}
                      readOnly
                    />
                    {salesDetail?.rating ? `(${salesDetail?.rating})` : ''}
                  </div>

                  <div style={{ marginTop: 5, marginBottom: 0 }}>
                    <span style={{ fontWeight: 700 }}># of Reviews:</span>{' '}
                    {salesDetail?.reviewCount ?? ''}
                  </div>
                </div>
              )}
            </TableCell>
            <TableCell
              style={{ minWidth: '80px', width: '9%', paddingLeft: '3px' }}
            >
              {row.marketplaces[0]}
            </TableCell>
            <TableCell
              style={{ minWidth: '80px', width: '8%', paddingLeft: '3px' }}
            >
              {row.price}
            </TableCell>
            <TableCell
              style={{ minWidth: '80px', width: '8%', paddingLeft: '3px' }}
            >
              {row.minimumPrice}
            </TableCell>
            <TableCell
              style={{ minWidth: '80px', width: '8%', paddingLeft: '3px' }}
            >
              {row.maximumPrice}
            </TableCell>
            <TableCell
              style={{ minWidth: '80px', width: '7%', paddingLeft: '3px' }}
            >
              {this.displayRepircingField(row)}
            </TableCell>
            <TableCell style={{ width: '100%' }}>
              {this.props.row.shortcode && this.props.row.quantity > 0 ? (
                <Tooltip title="Pricing Analysis">
                  <IconButton
                    onClick={() => this.handleLaunchClick(this.props.row)}
                  >
                    <InsightsIcon style={{ color: 'black' }} />
                  </IconButton>
                </Tooltip>
              ) : (
                <IconButton disabled>
                  <InsightsIcon style={{ visibility: 'hidden' }} />
                </IconButton>
              )}
              {this.displayNotesIcon(row)}
              <IconButton onClick={this.handleBuyBoxOpen}>
                {row.isBuyBoxWinner && row.has2BuyBoxWinners ? (
                  <ThumbUpAltIcon style={{ color: 'gray' }} />
                ) : row.isBuyBoxWinner && !row.has2BuyBoxWinners ? (
                  <ThumbUpAltIcon style={{ color: 'black' }} />
                ) : (
                  <ThumbUpOffAltIcon />
                )}
              </IconButton>
              <Popover
                open={this.isBuyBoxPopoverOpen()}
                anchorEl={this.state.buyBoxAnchorEl}
                onClose={this.handleBuyBoxPopoverClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
              >
                {this.buyBoxInformation(row)}
              </Popover>
              <StyledBadge
                badgeContent={row.relatedProducts?.length}
                color="secondary"
                style={{ marginLeft: '13px', marginRight: '13px' }}
              ></StyledBadge>
              <IconButton
                onClick={() => {
                  this.props.setCurrentPage(
                    PRICING_DASHBOARD_PAGES.DETAIL,
                    row.webstoreProductId
                  );
                }}
              >
                <KeyboardDoubleArrowRightIcon />
              </IconButton>
            </TableCell>
          </React.Fragment>
        );
    }

    displayListingRow = (listingIdBeingEdited) => {
        if (listingIdBeingEdited === this.props.row.webstoreProductId) {
            return this.displayEditingRow(this.props.row)
        } else {
            return this.displayNonEditingRow(this.props.row)
        }
    }

    parseNumber = (string) => {
        return parseFloat(string?.toString().replaceAll(',',''))
    }

    handleMinMaxBlur = (field) => {
      this.setState(prevState => {
        const updatedForm = { ...prevState.productForm };

        if (!updatedForm[field] || updatedForm[field] === '') {
          const pricing = this.calculatePricing(updatedForm);
          updatedForm[field] = pricing[field];
        } else {
          updatedForm[field] = parseFloat(updatedForm[field]).toFixed(2);
        }

        return { productForm: updatedForm };
      });
    };

    handlePackagingSelect = (packaging, product) => {
      const formattedPackaging = `Box/${packaging}`;
      const referralFee = this.props.automationSettings?.referralFee || 0;

      this.props.fetchBoxAndShippingCost({ packaging: formattedPackaging, currency: product.currency, shipAddressId: product?.shipAddressId }, (data) => {
        const updatedForm = {
          ...product,
          packaging: data.packaging,
          packagingCost: Number(data.boxCost || 0),
          avgShippingCost: Number(data.shippingCost || 0),
          ftlCost: Number(product.ftlCost || 0),
          productCost: Number(product.productCost || 0),
          price: Number(product.price),
          referralFee
        };

        const pricing = this.calculatePricing(updatedForm);

        this.setState({
          productForm: { ...updatedForm, ...pricing }
        });
      });
    };

    resetMinTo15 = () => {
      this.setState(prev => {
        const { totalCost = 0, referralFee = 0 } = prev.productForm;

        const referralRate = Number(referralFee) / 100;
        const minMarginRate = 0.15;
        const denominator = 1 - referralRate - minMarginRate;

        const minPrice = denominator > 0
          ? (totalCost / denominator).toFixed(2)
          : "0.00";

        return {
          productForm: {
            ...prev.productForm,
            min: minPrice
          }
        };
      });
    };

    resetMaxTo35 = () => {
      this.setState(prev => {
        const { totalCost = 0, referralFee = 0 } = prev.productForm;
        const referralRate = Number(referralFee) / 100;
        const maxMarginRate = 0.35;
        const denominator = 1 - referralRate - maxMarginRate;

        const maxPrice = denominator > 0
          ? (totalCost / denominator).toFixed(2)
          : "0.00";

        return {
          productForm: {
            ...prev.productForm,
            max: maxPrice
          }
        };
      });
    };

    calculatePricing = ({
      price = 0,
      productCost = 0,
      packagingCost = 0,
      avgShippingCost = 0,
      ftlCost = 0,
      packOf = 1,
      referralFee = 0,
      minMarginRate = 0.15,
      maxMarginRate = 0.35,
      min = 0,
      max = 0
    }) => {
      const quantity = Number(packOf);
      const referralRate = Number(referralFee) / 100;

      const totalProductCost = Number(productCost) * quantity;
      const totalCost =
        totalProductCost + Number(packagingCost) + Number(avgShippingCost) + Number(ftlCost) * quantity;

      const profit = price * (1 - referralRate) - totalCost;
      const margin = price > 0 ? ((profit / price) * 100).toFixed(2) : "0.00";

      const minPriceDenominator = 1 - referralRate - minMarginRate;
      const maxPriceDenominator = 1 - referralRate - maxMarginRate;


      const minPrice = min ?  min : minPriceDenominator > 0 ? (totalCost / minPriceDenominator).toFixed(2) : "0.00";
      const maxPrice = max ?  max : maxPriceDenominator > 0 ? (totalCost / maxPriceDenominator).toFixed(2) : "0.00";

      const profitPerUnit = quantity > 0 ? (profit / quantity).toFixed(2) : "0.00";

      return {
        totalCost,
        profit: profit.toFixed(2),
        profitPerUnit,
        margin,
        min: minPrice,
        max: maxPrice
      };
    };

    render() {

        return (
          <React.Fragment>
            <Dialog
              open={this.state.dialogOpen}
              onClose={this.handleDialogClose}
              maxWidth={false}
              PaperProps={{
                style: {
                  width: '90%',
                  maxWidth: '1280px',
                },
              }}
            >
              <DialogTitle style={{ marginLeft: '24px', marginTop: '16px' }}>
                {' '}
                Pricing Analysis
              </DialogTitle>
              <DialogContent>
                <Grid
                  container
                  spacing={3}
                  style={{ marginTop: '16px', paddingLeft: '24px' }}
                >
                  {/* Row 1 */}
                  <Grid container item spacing={2}>
                    <Grid item>
                      <TextField
                        label="Shortcode"
                        variant="outlined"
                        value={this.state.productForm.shortcode}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        disabled={true}
                        sx={{ minWidth: 200 }}
                      />
                    </Grid>
                    <Grid item>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          flexDirection: 'column',
                        }}
                      >
                        <TextField
                          label="Price"
                          variant="outlined"
                          value={this.state.productForm.price}
                          onChange={this.handleFormChange('price')}
                          inputProps={{ style: { textAlign: 'right' } }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                {'$'}
                              </InputAdornment>
                            ),
                            readOnly: false,
                          }}
                          InputLabelProps={{ shrink: true }}
                          onBlur={() => {
                            this.setState((prev) => {
                              const price =
                                parseFloat(prev.productForm.price) || 0;
                              return {
                                productForm: {
                                  ...prev.productForm,
                                  price: price.toFixed(2),
                                },
                              };
                            });
                          }}
                          fullWidth
                          style={{ width: '223px' }}
                        />
                        {this.userHasMarginPricingAnalysisPermission() && (
                          <div className="pricePercentage">
                            Margin: {this.state.productForm.margin}%
                          </div>
                        )}
                      </div>
                    </Grid>
                    <Grid item>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          flexDirection: 'column',
                        }}
                      >
                        <div>
                          <TextField
                            label="Minimum"
                            variant="outlined"
                            value={this.state.productForm.min}
                            inputProps={{ style: { textAlign: 'right' } }}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  {'$'}
                                </InputAdornment>
                              ),
                              readOnly: false,
                            }}
                            style={{ width: '223px' }}
                            onChange={(e) => {
                              const value = e.target.value;
                              this.setState((prev) => ({
                                productForm: {
                                  ...prev.productForm,
                                  min: value,
                                },
                              }));
                            }}
                            onBlur={() => this.handleMinMaxBlur('min')}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                          />
                        </div>
                        {this.userHasMarginPricingAnalysisPermission() && (
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              width: '100%',
                            }}
                          >
                            <Tooltip
                              style={{ marginLeft: '-12px' }}
                              title={
                                'Reset minimum suggested price to 15% margin'
                              }
                            >
                              <IconButton onClick={this.resetMinTo15}>
                                <RefreshIcon />
                              </IconButton>
                            </Tooltip>

                            <div>
                              Margin:{' '}
                              {this.state.productForm.min &&
                              parseFloat(this.state.productForm.min) > 0
                                ? (
                                    ((parseFloat(this.state.productForm.min) *
                                      (1 -
                                        this.state.productForm.referralFee /
                                          100) -
                                      this.state.productForm.totalCost) /
                                      parseFloat(this.state.productForm.min)) *
                                    100
                                  ).toFixed(2)
                                : '0.00'}
                              %
                            </div>
                          </div>
                        )}
                      </div>
                    </Grid>
                    <Grid item>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          flexDirection: 'column',
                        }}
                      >
                        <div>
                          <TextField
                            label="Maximum"
                            variant="outlined"
                            value={this.state.productForm.max}
                            inputProps={{ style: { textAlign: 'right' } }}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  {'$'}
                                </InputAdornment>
                              ),
                              readOnly: false,
                            }}
                            style={{ width: '223px' }}
                            onChange={(e) => {
                              const value = e.target.value;
                              this.setState((prev) => ({
                                productForm: {
                                  ...prev.productForm,
                                  max: value,
                                },
                              }));
                            }}
                            onBlur={() => this.handleMinMaxBlur('max')}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                          />
                        </div>
                        {this.userHasMarginPricingAnalysisPermission() && (
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              width: '100%',
                            }}
                          >
                            <Tooltip
                              style={{ marginLeft: '-12px' }}
                              title={
                                'Reset maximum suggested price to 35% margin'
                              }
                            >
                              <IconButton onClick={this.resetMaxTo35}>
                                <RefreshIcon />
                              </IconButton>
                            </Tooltip>

                            <div>
                              Margin:{' '}
                              {this.state.productForm.max &&
                              parseFloat(this.state.productForm.max) > 0
                                ? (
                                    ((parseFloat(this.state.productForm.max) *
                                      (1 -
                                        this.state.productForm.referralFee /
                                          100) -
                                      this.state.productForm.totalCost) /
                                      parseFloat(this.state.productForm.max)) *
                                    100
                                  ).toFixed(2)
                                : '0.00'}
                              %
                            </div>
                          </div>
                        )}
                      </div>
                    </Grid>
                    <Grid item>
                      <TextField
                        label="Currency"
                        disabled={true}
                        variant="outlined"
                        value={this.state.productForm.currency}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        sx={{ minWidth: 200 }}
                      />
                    </Grid>
                  </Grid>

                  {/* Row 2 */}
                  <Grid container item spacing={2}>
                    <Grid item>
                      <TextField
                        label="Pack of"
                        variant="outlined"
                        value={this.state.productForm.packOf}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        disabled={true}
                        sx={{ minWidth: 200 }}
                      />
                    </Grid>
                    <Grid item>
                      <TextField
                        variant="outlined"
                        name="referralFee"
                        label="Referral Fee"
                        value={this.state.productForm.referralFee}
                        onChange={this.handleFormChange('referralFee')}
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">%</InputAdornment>
                          ),
                        }}
                        style={{ width: '223px' }}
                      />
                    </Grid>

                    {this.userHasPackagingCostAnalysisPermission() && (
                      <Grid item>
                        <TextField
                          label="Packaging Cost"
                          variant="outlined"
                          value={this.state.productForm.packagingCost}
                          onChange={this.handleFormChange('packagingCost')}
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                          inputProps={{ style: { textAlign: 'right' } }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                {'$'}
                              </InputAdornment>
                            ),
                            readOnly: false,
                          }}
                          style={{ width: '223px' }}
                        />
                      </Grid>
                    )}

                    {this.userHasShippingCostAnalysisPermission() && (
                      <Grid item>
                        <TextField
                          label="Average Shipping Cost"
                          variant="outlined"
                          value={this.state.productForm.avgShippingCost}
                          onChange={this.handleFormChange('avgShippingCost')}
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                          inputProps={{ style: { textAlign: 'right' } }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                {'$'}
                              </InputAdornment>
                            ),
                            readOnly: false,
                          }}
                          style={{ width: '223px' }}
                        />
                      </Grid>
                    )}

                    {this.userHasFTLCostAnalysisPermission() && (
                      <Grid item>
                        <TextField
                          label="FTL Cost (Per Unit)"
                          variant="outlined"
                          value={this.state.productForm.ftlCost}
                          onChange={this.handleFormChange('ftlCost')}
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                          inputProps={{ style: { textAlign: 'right' } }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                {'$'}
                              </InputAdornment>
                            ),
                            readOnly: false,
                          }}
                          style={{ width: '223px' }}
                        />
                      </Grid>
                    )}
                  </Grid>

                  {/* Row 3 */}
                  <Grid
                    container
                    item
                    spacing={2}
                    style={{
                      marginTop: this.userHasMarginPricingAnalysisPermission()
                        ? '8px'
                        : '-8px',
                    }}
                  >
                    <Grid item style={{ width: '478px' }}>
                      <Autocomplete
                        className="pricing-row-packaging"
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        options={this.state.allBoxes}
                        getOptionLabel={(option) => option}
                        autoHighlight={true}
                        onChange={(event, value) => {
                          this.setState((prevState) => ({
                            productForm: {
                              ...prevState.productForm,
                              packaging: value || '', // value is the selected option
                            },
                          }));
                          if (value) {
                            this.handlePackagingSelect(
                              value,
                              this.state.productForm
                            );
                          }
                        }}
                        // onChange={this.handleFormChange('packaging')}
                        value={this.state.productForm.packaging}
                        name="packaging"
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Packaging"
                            required
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            name="packaging"
                          />
                        )}
                      />
                    </Grid>

                    {this.userHasProductCostAnalysisPermission() && (
                      <Grid item>
                        <TextField
                          label="Product Cost (Per Unit)"
                          variant="outlined"
                          value={this.state.productForm.productCost}
                          onChange={this.handleFormChange('productCost')}
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                          inputProps={{ style: { textAlign: 'right' } }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                {'$'}
                              </InputAdornment>
                            ),
                            readOnly: false,
                          }}
                          style={{ width: '223px' }}
                        />
                      </Grid>
                    )}

                    {this.userHasProfitAnalysisPermission() && (
                      <>
                        <Grid item>
                          <TextField
                            label="Profit"
                            variant="outlined"
                            value={this.state.productForm.profit}
                            onChange={this.handleFormChange('profit')}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            inputProps={{ style: { textAlign: 'right' } }}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  {'$'}
                                </InputAdornment>
                              ),
                              readOnly: false,
                            }}
                            style={{ width: '223px' }}
                          />
                        </Grid>
                        <Grid item>
                          <TextField
                            label="Profit Per Unit"
                            variant="outlined"
                            value={this.state.productForm.profitPerUnit}
                            onChange={this.handleFormChange('profitPerUnit')}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            inputProps={{ style: { textAlign: 'right' } }}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  {'$'}
                                </InputAdornment>
                              ),
                              readOnly: false,
                            }}
                            style={{ width: '223px' }}
                          />
                        </Grid>
                      </>
                    )}
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions
                style={{
                  marginBottom: '16px',
                  justifyContent: 'center',
                  gap: '16px',
                }}
              >
                <Button onClick={this.handleDialogClose}>Cancel</Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.handleApply}
                >
                  Apply
                </Button>
              </DialogActions>
            </Dialog>
            {this.displayListingRow(this.props.listingIdBeingEdited)}
          </React.Fragment>
        );
    }
}

PricingDashboardTableRow.defaultProps = {
    newPrice: 0,
    newMinimum: 0,
    newMaximum: 0,
    newRepricing: false,
    salesData:{}
}

PricingDashboardTableRow.propTypes = {
}

const mapStateToProps = (state) => ({
})

const actionCreators = {
    updatePricingListing,
    updateRepricing,

}

export default withShipment({
    mapStateToProps,
    actionCreators
}, PricingDashboardTableRow);